import { FontIcon } from 'react-md'
import styled from 'styled-components'
import { maxScreenWidth } from 'ui/StyledComponents/MediaBreakpoints'

const Card = styled.div`
	display: flex;
	flex-direction: column;
	background: var(--color-secondary);
	border-radius: 8px;
	box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 33%);
	color: #fff;
	margin-top: 0;
	margin-bottom: 64px;
	padding: 0 48px;
	z-index: 10;
	width: 60%;

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		width: 100%;
		padding: 0 24px;
	}
`

const CardTitle = styled.h2`
	font-size: 3rem;
	color: #fff;
	margin-bottom: 32px;

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		font-size: 2rem;
	}
`

const Feature = styled.div`
	margin-bottom: 32px;
`

const FeatureTitleContainer = styled.div`
	display: flex;
	place-items: center;
`

const FeatureTitle = styled.h3`
	color: #fff;
	margin: 0;
	margin-left: 16px;
	font-weight: 600;
	font-size: 25px;

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		font-size: 20px;
	}
`

const FeatureIcon = styled.span`
	width: 50px;
	height: 50px;
	flex-shrink: 0;
	flex-grow: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border-radius: 50%;
`

const FeatureDescription = styled.div`
	font-weight: 200;
	font-size: 20px;
	color: #fff;
	line-height: 1.333;
	margin: 20px 0;

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		font-size: 18px;
	}
`

function FeatureCard({ title, features, style = {} }) {
	return (
		<Card style={{ ...style }}>
			<CardTitle>{title}</CardTitle>
			{features.map((feature) => (
				<Feature key={feature.title}>
					<FeatureTitleContainer>
						<FeatureIcon>
							<FontIcon
								style={{ color: 'var(--color-secondary)', fontSize: 24 }}
							>
								{feature.icon}
							</FontIcon>
						</FeatureIcon>
						<FeatureTitle>{feature.title}</FeatureTitle>
					</FeatureTitleContainer>

					<FeatureDescription>
						{feature.description}
						<span style={{ marginLeft: 8 }}>
							{feature.featureAction && feature.featureAction}
						</span>
					</FeatureDescription>
				</Feature>
			))}
		</Card>
	)
}

export default FeatureCard
